baseApp.service('FailoverConfigurationService', ['$window', function($window){
    let serviceInstance = {};

    let cachedDefaultValue = {};
    const SYSTEM_DEFAULTS_ACCOUNT_ID = 1;

    function getNullSafeInstance() {
        return {
            activeActiveFailoverConfiguration: {
                activeActiveQualityThresholds: {},
            },
            activePassiveFailoverConfiguration: {
                activePassiveQualityThresholds: {},
            },
            keepAliveConfiguration: {},
        }
    }

    serviceInstance.getConfiguration = function(accountId, siteId, onSuccess, onError) {
        store.fetch({
            method: "GET",
            path: "/getFailoverConfig",
            queryParams: {
              accountId: accountId,
              siteId: siteId,
            },
            success: function success(response) {
                if(response.status == "OK") {
                    if(!response.model) {
                        response.model = serviceInstance.buildEmptyModel();
                    }
                    onSuccess(_.merge(getNullSafeInstance(), response.model));
                } else {
                    if(onError) {
                        onError(response.notifications);
                    }
                }
            }
          });
    };



    serviceInstance.getDefault = function(accountId, onSuccess, onError) {
        if(cachedDefaultValue.accountId == accountId) {
            onSuccess(cachedDefaultValue);
            return;
        }
        store.fetch({
            method: "GET",
            path: "/getDefaultFailoverConfig",
            queryParams: {
              accountId: accountId,
            },
            success: function success(response) {
                if(response.status == "OK") {
                    cachedDefaultValue = response.model;
                    cachedDefaultValue.accountId = accountId;
                    onSuccess(cachedDefaultValue);
                } else {
                    if(onError) {
                        onError(response.notifications);
                    }
                }
            }
        });
    }

    serviceInstance.getSystemDefault = function(onSuccess, onError) {
        if(cachedDefaultValue.accountId == SYSTEM_DEFAULTS_ACCOUNT_ID) {
            onSuccess(cachedDefaultValue);
            return;
        }
        store.fetch({
            method: "GET",
            path: "/getSystemDefaultFailoverConfig",
            success: function success(response) {
                if(response.status == "OK") {
                    cachedDefaultValue = response.model;
                    cachedDefaultValue.accountId = SYSTEM_DEFAULTS_ACCOUNT_ID;
                    onSuccess(cachedDefaultValue);
                } else {
                    if(onError) {
                        onError(response.notifications);
                    }
                }
            }
        });
    }

    serviceInstance.buildEmptyModel = function() {
        let newInstance = {
            type: "FAILOVERCONFIGURATION",
            name: "FailoverConfiguration",
            isNew: true,
        };
        return newInstance;
    };

    serviceInstance.unitToLabelText = function(unit) {
        switch(unit) {
            case 'SECONDS':
                return 's';
            case 'MINUTES':
                return 'min';
            case 'HOURS':
                return 'hrs';
            default:
                return '';
        }
    };

    return serviceInstance;
}]);